import React, { useState, useContext, useEffect } from "react";
import * as S from "./ExtrairDadosStyle";
import { AuthContext } from "../../Context/AuthContext";
import Loading from "../Loader";
import { useNavigate } from "react-router-dom";
import { extractDataService } from "../../Services/extractDataService";
import { auditService } from "../../Services/auditService";

const contratosStatusFilter = [
  { name: "Todos", value: "" },
  { name: "Valorizando", value: "1" },
  { name: "Finalizado", value: "2" },
  { name: "Cancelado", value: "3" },
  { name: "Pendente", value: "4" },
];

const saqueStatusFilter = [
  { name: "Todos", value: "" },
  { name: "Pendentes", value: "1" },
  { name: "Pagos", value: "2" },
  { name: "Cancelados", value: "3" },
];

const goldenBoxStatusFilter = [
  { name: "Todos", value: "" },
  { name: "Pendente", value: "1" },
  { name: "Ativa", value: "2" },
  { name: "Finalizada", value: "3" },
  { name: "Rejeitada", value: "4" },
  { name: "Cancelada", value: "5" },
];

const goldenBoxWithdrawStatusFilter = [
  { name: "Todos", value: "" },
  { name: "Pendentes", value: "1" },
  { name: "Pagos", value: "2" },
  { name: "Cancelados", value: "3" },
  { name: "Rejeitados", value: "4" },
];

const contratosRecebidosAMaisTypes = [
  "contratosrecebidosamais",
  "contratosrecebidosamaissemdivergencia",
];

export default function ExtrairDados() {
  const { authState } = useContext(AuthContext);
  const [type, setType] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [orderFilter, setOrderFilter] = useState("desc");
  const [orderField, setOrderField] = useState("date");
  const [filtroString, setFiltroString] = useState("");
  const [consultorId, setConsultorId] = useState("");
  const [monthFilter, setMonthFilter] = useState("");
  const [yearFilter, setYearFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isRepurchaseContratoFilter, setIsRepurchaseContratoFilter] =
    useState("");
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();

  const handleChangeType = (e) => {
    const newType = e.target.value;
    setType(newType);
    setStatusFilter("");
    setOrderFilter(
      contratosRecebidosAMaisTypes.includes(newType) ? "asc" : "desc"
    );
    setOrderField("date");
    setConsultorId("");
    setFiltroString("");
    setMonthFilter("");
    setYearFilter("");
    setStartDate("");
    setEndDate("");
    setIsRepurchaseContratoFilter("");
  };

  const handleDownload = async () => {
    setLoad(true);
    try {
      await extractDataService.downloadReport({
        orderFilter,
        orderField,
        statusFilter: type !== "dinheiroinvestido" ? statusFilter : "",
        searchTerm: type !== "dinheiroinvestido" ? filtroString : "",
        type,
        monthFilter: startDate ? "" : monthFilter,
        yearFilter: startDate ? "" : yearFilter,
        consultorId,
        startDate,
        endDate,
        isRepurchase: isRepurchaseContratoFilter,
      });
    } catch (err) {
      console.log(err);
      alert("Houve um erro ao fazer o download do relatório.");
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      <Loading load={load} />
      <S.ExtrairContainer>
        <S.ContentBox>
          <S.Header>
            <h2>Extrair Relatórios</h2>
            <p>
              Selecione o tipo de dado e os filtros desejados para gerar seu
              relatório em CSV.
            </p>
          </S.Header>

          <S.Step>
            <span className="title">
              Passo 1: Selecione o tipo de relatório
            </span>
            <S.InputGroup>
              <label>Extrair Dados de:</label>
              <select value={type} onChange={handleChangeType}>
                <option value="">Selecione uma opção...</option>
                <option value="clientes">Clientes</option>
                <option value="contratos">Contratos</option>
                <option value="contratosrecebidosamais">
                  Contratos que Receberam a Mais (considerando os 3% de 150-147)
                </option>
                <option value="contratosrecebidosamaissemdivergencia">
                  Contratos que Receberam a Mais (desconsiderando os 3% de
                  150-147)
                </option>
                <option value="saques">Saques</option>
                <option value="goldenboxes">Golden Boxes (Caixinhas)</option>
                <option value="saquesgoldenboxes">Saques Golden Box</option>
                <option value="dinheiroinvestido">
                  Aplicações (Dinheiro Investido)
                </option>
              </select>
            </S.InputGroup>
          </S.Step>

          {type && (
            <S.Step>
              <span className="title">
                Passo 2: Aplique os filtros (Opcional)
              </span>
              <S.Filters>
                {/* FILTROS PARA CONTRATOS */}
                {type === "contratos" && (
                  <>
                    <S.InputGroup>
                      <label>Status do Contrato</label>
                      <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        {contratosStatusFilter.map((it) => (
                          <option key={it.value} value={it.value}>
                            {it.name}
                          </option>
                        ))}
                      </select>
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>É Recompra?</label>
                      <select
                        value={isRepurchaseContratoFilter}
                        onChange={(e) =>
                          setIsRepurchaseContratoFilter(e.target.value)
                        }
                      >
                        <option value="">Todos</option>
                        <option value="true">Sim</option>
                        <option value="false">Não</option>
                      </select>
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Data Inicial</label>
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Data Final</label>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </S.InputGroup>
                  </>
                )}

                {/* FILTROS PARA CONTRATOS QUE RECEBERAM A MAIS (data da compra) */}
                {contratosRecebidosAMaisTypes.includes(type) && (
                  <>
                    <S.InputGroup>
                      <label>Data da Compra (Inicial)</label>
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Data da Compra (Final)</label>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </S.InputGroup>
                  </>
                )}

                {/* FILTROS PARA SAQUES COMUNS */}
                {type === "saques" && (
                  <>
                    <S.InputGroup>
                      <label>Status do Saque</label>
                      <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        {saqueStatusFilter.map((it) => (
                          <option key={it.value} value={it.value}>
                            {it.name}
                          </option>
                        ))}
                      </select>
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Mês</label>
                      <select
                        value={monthFilter}
                        onChange={(e) => setMonthFilter(e.target.value)}
                        disabled={!!startDate || !!endDate}
                      >
                        <option value="">Todos</option>
                        {[...Array(12).keys()].map((i) => (
                          <option key={i + 1} value={i + 1}>
                            {new Date(0, i).toLocaleString("pt-BR", {
                              month: "long",
                            })}
                          </option>
                        ))}
                      </select>
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Ano</label>
                      <select
                        value={yearFilter}
                        onChange={(e) => setYearFilter(e.target.value)}
                        disabled={!!startDate || !!endDate}
                      >
                        <option value="">Todos</option>
                        {[...Array(7).keys()].map((i) => (
                          <option key={2026 - i} value={2026 - i}>
                            {2026 - i}
                          </option>
                        ))}
                      </select>
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Data Inicial</label>
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                          setMonthFilter("");
                          setYearFilter("");
                        }}
                      />
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Data Final</label>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                          setMonthFilter("");
                          setYearFilter("");
                        }}
                      />
                    </S.InputGroup>
                  </>
                )}

                {/* FILTRO DE CLIENTE (COMUM A QUASE TODOS) */}
                {type !== "dinheiroinvestido" && (
                  <S.InputGroup>
                    <label>Filtrar por Cliente (Nome ou CPF)</label>
                    <input
                      value={filtroString}
                      onChange={(e) => setFiltroString(e.target.value)}
                      placeholder="Deixe em branco para todos"
                    />
                  </S.InputGroup>
                )}

                {/* FILTRO DE CONSULTOR (CLIENTES) */}
                {type === "clientes" && (
                  <S.InputGroup>
                    <label>Filtrar por ID do Consultor</label>
                    <input
                      value={consultorId}
                      onChange={(e) => setConsultorId(e.target.value)}
                      placeholder="ID do Consultor"
                    />
                  </S.InputGroup>
                )}

                {/* FILTROS PARA GOLDEN BOXES (CAIXINHAS) */}
                {type === "goldenboxes" && (
                  <S.InputGroup>
                    <label>Status da Caixinha</label>
                    <select
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                    >
                      {goldenBoxStatusFilter.map((it) => (
                        <option key={it.value} value={it.value}>
                          {it.name}
                        </option>
                      ))}
                    </select>
                  </S.InputGroup>
                )}

                {/* FILTROS PARA SAQUES GOLDEN BOXES */}
                {type === "saquesgoldenboxes" && (
                  <>
                    <S.InputGroup>
                      <label>Status do Saque (Golden Box)</label>
                      <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        {goldenBoxWithdrawStatusFilter.map((it) => (
                          <option key={it.value} value={it.value}>
                            {it.name}
                          </option>
                        ))}
                      </select>
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Mês</label>
                      <select
                        value={monthFilter}
                        onChange={(e) => setMonthFilter(e.target.value)}
                        disabled={!!startDate || !!endDate}
                      >
                        <option value="">Todos</option>
                        {[...Array(12).keys()].map((i) => (
                          <option key={i + 1} value={i + 1}>
                            {new Date(0, i).toLocaleString("pt-BR", {
                              month: "long",
                            })}
                          </option>
                        ))}
                      </select>
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Ano</label>
                      <select
                        value={yearFilter}
                        onChange={(e) => setYearFilter(e.target.value)}
                        disabled={!!startDate || !!endDate}
                      >
                        <option value="">Todos</option>
                        {[...Array(7).keys()].map((i) => (
                          <option key={2026 - i} value={2026 - i}>
                            {2026 - i}
                          </option>
                        ))}
                      </select>
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Data Inicial</label>
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                          setMonthFilter("");
                          setYearFilter("");
                        }}
                      />
                    </S.InputGroup>
                    <S.InputGroup>
                      <label>Data Final</label>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                          setMonthFilter("");
                          setYearFilter("");
                        }}
                      />
                    </S.InputGroup>
                  </>
                )}

                {/* ORDENAÇÃO POR CAMPO (APARECE PARA SAQUES E SAQUES GOLDEN BOX) */}
                {(type === "saques" || type === "saquesgoldenboxes") && (
                  <S.InputGroup>
                    <label>Ordenar por campo:</label>
                    <select
                      value={orderField}
                      onChange={(e) => setOrderField(e.target.value)}
                    >
                      <option value="date">Data do Saque</option>
                      <option value="name">Nome do Cliente (A-Z)</option>
                      <option value="amount">Valor do Saque</option>
                    </select>
                  </S.InputGroup>
                )}

                <S.InputGroup>
                  <label>Sentido da Ordenação</label>
                  <select
                    value={orderFilter}
                    onChange={(e) => setOrderFilter(e.target.value)}
                  >
                    {contratosRecebidosAMaisTypes.includes(type) ? (
                      <>
                        <option value="asc">Nome do Cliente (A-Z)</option>
                        <option value="desc">Nome do Cliente (Z-A)</option>
                      </>
                    ) : (
                      <>
                        <option value="desc">Decrescente (Recentes/Maiores)</option>
                        <option value="asc">Crescente (Antigos/Menores)</option>
                      </>
                    )}
                  </select>
                </S.InputGroup>
              </S.Filters>
            </S.Step>
          )}

          <S.Download>
            <button onClick={handleDownload} disabled={!type}>
              Extrair Relatório
            </button>
          </S.Download>
        </S.ContentBox>
      </S.ExtrairContainer>
    </>
  );
}
